import { action } from 'lib/actions';

export const pushPath = action('router/PUSH_PATH');
export const updateQuery = action('router/UPDATE_QUERY');

